import {
  put,
  call,
  take,
  every,
  takeLatest,
  takeEvery,
} from "redux-saga/effects";
import * as CONST from "./actionTypes";
import * as ACTION from "./actions";
import { toast } from "react-toastify";
import { LOGIN_ADMIN } from "../../services/ApiCalls";
import { useState } from "react";

// const [loader , setLoader] = useState(null);
// function* loginUserSaga({ payload, callBack }) {
//   try {
//     const response = yield call(LOGIN_ADMIN, payload);

//     console.log(response,"login response")

//     if (response.data.status == "success") {
//       // toast.success(response?.data?.message);
//       localStorage.setItem("token", response?.data?.data?.token || "");
//       localStorage.setItem("_id", response?.data?.data?._id);
//       localStorage.setItem(
//         "profileImage",
//         response?.data?.data?.profileImage
//       );
//       localStorage.setItem("name", response?.data?.data?.name);
//       localStorage.setItem("email", response?.data?.data?.email);
//       localStorage.setItem(
//         "role",
//         JSON.stringify(response?.data?.data?.role)
//       );

//       // if (
//       //   response.data.data.permissions &&
//       //   response.data.data.permissions?.length > 0
//       // ) {
//       //   localStorage.setItem(
//       //     "permissions",
//       //     JSON.stringify(response.data.data.permissions)
//       //   );
//       // } else {
//       //   localStorage.setItem("permissions", JSON.stringify([]));
//       // }
//       // localStorage.setItem("countryCode", response?.data?.country_code);
//       // localStorage.setItem("mobileNumber", response?.data?.full_phone_number);

//       callBack && callBack(response?.data);
//       yield put(ACTION.loginAdmin_Success(response?.data));
//     } else {
//       // setLoader(false);
//       callBack && callBack(response);
//       yield put(ACTION.loginAdmin_Fail(response));
//     }
//   } catch (error) {
//     console.log(error,"error saga====<>")
//     yield put(ACTION.loginAdmin_Fail(error));
//   }
// }
function* loginUserSaga({ payload, callBack }) {
  try {
    const response = yield call(LOGIN_ADMIN, payload);
    console.log(response, "login response");
    const resData = response?.data;

    if (resData?.status === "success") {
      localStorage.setItem("token", resData?.data?.token || "");
      localStorage.setItem("firebaseToken", payload?.firebaseToken || "");
      localStorage.setItem("_id", resData?.data?._id || "");
      localStorage.setItem("profileImage", resData?.data?.profileImage || "");
      localStorage.setItem("name", resData?.data?.name || "");
      localStorage.setItem("email", resData?.data?.email || "");
      localStorage.setItem("role", JSON.stringify(resData?.data?.role || []));
      localStorage.setItem("permission", JSON.stringify(resData?.data?.permission?.permission || "{}"));
      callBack && callBack(resData, null);
      yield put(ACTION.loginAdmin_Success(resData));
    } else {
      const errorMessage = resData?.message || "Login failed !";
      callBack && callBack(null, { message: errorMessage });
      yield put(ACTION.loginAdmin_Fail(resData));
    }
  } catch (error) {
    console.log(error, "error saga====<>");
    const errorMessage = error?.response?.data?.message || error?.message || "Something went wrong !";
    callBack && callBack(null, { message: errorMessage });
    yield put(ACTION.loginAdmin_Fail(error));
  }
}

function* LoginSaga() {
  yield takeEvery(CONST.LOGIN_ADMIN, loginUserSaga);
}

export default LoginSaga;
